<template>

    <div class="container">

        <div class="my-4">
            <h1>{{ __('Organisation') }}</h1>
        </div>

        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            <div class="col" v-for="card in cards">
                <div class="card h-100 shadow-sm">
                    <div class="card-body">
                        <h5 class="card-title">
                            <inertia-link :href="card.url" class="stretched-link">
                                {{ card.title }}
                            </inertia-link>
                        </h5>
                        <p class="card-text">
                            {{ card.text }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    export default {
        props: [
            'account',
        ],
        data() {
            return {
                cards: [
                    {title: this.__('Bestellungen'), text: 'Verwalten Sie Ihre Bestellungen und Bestellvorlagen.', url: this.route('orders.index')},
                    {title: this.__('Stammdaten'), text: 'Verwalten Sie die Stammdaten Ihrer Organisation.', url: this.route('account.edit', this.account)},
                    {title: this.__('Benutzer'), text: 'Verwalten Sie Benutzerkonten innerhalb Ihrer Organisation.', url: this.route('users.index')},
                    {title: this.__('Adressen'), text: 'Verwalten Sie Liefer- und Rechnungsadressen.', url: this.route('addresses.index')},
                    {title: this.__('Favoriten'), text: 'Verwalten Sie Ihre favorisierten Lieferanten und Hersteller.', url: this.route('favorites.index')},
                    {title: this.__('Nachrichten'), text: 'Kommunizieren Sie mit Lieferanten und Herstellern..', url: this.route('messages.index')},
                ]
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>